import translate from '../../translations'

export default data => {
  const str = `
    <div class="card__inner">
      <div class="card__top">
        <div class="card__heading">
          <span>
             ${data.tag}
          </span>
          <span class="card__date">
            ${data.date}
          </span>
         </div>
         <div class="card__content">
            <h2 class="card__title">${data.title}</h2>
          <div class="card__text">
            ${data.desc}
          </div>
         </div>
        </div>
        <div class="card__bottom">
          <a href="${
  data.fileURL
}" target="_blank" class="link link--medium link--blue-light" rel="nofollow">
            ${translate('DOWNLOAD_PRESS')}
          </a>
        </div>
      </div>`

  return str
}
